import { Fragment, useEffect, useState } from 'react';
import { Button, Space, Row, Col, Modal } from 'antd';
import { Link, useNavigate, useLocation, useParams } from 'react-router-dom';
import QuestionItemCom from './components/QuestionItemCom';
import { getStatisticalDataApi, getStatisticalOverviewApi } from '@services/Wj/Statistical';
import dayjs from 'dayjs';
import './index.less';
import PageHeader from '@components/PageHeader/PageHeader';

const ChartsSurvey = () => {
    useEffect(() => {
        document.title = '统计图表-医调研';
    }, []);

    const location = useLocation();
    const params = useParams();
    const navigate = useNavigate();

    const [data, setData] = useState([]);
    const [allData, setAllData] = useState({});

    const [isModalOpen, setIsModalOpen] = useState(false);

    const getAllData = async () => {
        const res = await getStatisticalOverviewApi({
            surveyId: location.state?.id || null,
        });
        if (res.status_code === 200) {
            setAllData(res?.data);
        }
    };

    const getData = async () => {
        const res = await getStatisticalDataApi({
            surveyId: location.state?.id || null,
        });

        if (res.status_code === 200) {
            setData(res?.data);
        }
    };

    useEffect(() => {
        console.log(location, params, 'location');
        getAllData();
        getData();
    }, []);

    const goDetails = () => {
        navigate(`/wj/surveys/${location.state.id}/details`, {
            state: location.state,
        });
    };

    const goCostomReport = () => {
        navigate(`/wj/surveys/${location.state.id}/customreport`, {
            state: location.state,
        });
    };
    const handleOk = () => {
        gotoReport();
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const gotoReport = () => {
        navigate(`/wj/surveys/${location.state.id}/report`, {
            state: location.state,
        });
    };

    return (
        <div className="survey_charts_wrap">
            <PageHeader breadcrumb={[]}>
                <Link to="/wj/surveys" className="back">
                    <i className="bi bi-chevron-left"></i>
                </Link>
                {location.state?.name || ''}
            </PageHeader>
            <div className="main_content">
                <div className="left">
                    <p className="active menu-pointer">
                        <i className="bi bi-graph-up"></i> &nbsp;&nbsp;统计图表
                    </p>
                    <p className="menu-pointer" onClick={goDetails}>
                        <i className="bi bi-archive"></i>
                        &nbsp;&nbsp;数据详情
                    </p>
                    <p className="menu-pointer" onClick={goCostomReport}>
                        <i className="bi bi-file-text"></i>
                        &nbsp;&nbsp;调研报告
                    </p>
                </div>
                <div className="right">
                    <div className="head">
                        <h2>数据概况</h2>
                        <div>
                            <Row className="data_wrap">
                                <Col span={8}>
                                    <Space orientation="vertical">
                                        <span>有效数据</span>
                                        <span className="font_blod">{allData?.effective || 0}</span>
                                    </Space>
                                </Col>
                                <Col span={8}>
                                    <Space orientation="vertical">
                                        <span>今日有效数据</span>
                                        <span className="font_blod">{allData?.todayEffective || 0}</span>
                                    </Space>
                                </Col>
                                <Col span={8}>
                                    <Space orientation="vertical">
                                        <span>平均完成时间</span>
                                        <p className="time_wrap">
                                            {dayjs.duration(allData?.avgDuration || 0, 'seconds').hours() === 0 ? null : (
                                                <>
                                                    <span>{dayjs.duration(allData?.avgDuration || 0, 'seconds').hours()}</span>时
                                                </>
                                            )}
                                            {dayjs.duration(allData?.avgDuration || 0, 'seconds').minutes() === 0 ? null : (
                                                <>
                                                    <span>{dayjs.duration(allData?.avgDuration || 0, 'seconds').minutes()}</span>分
                                                </>
                                            )}
                                            {dayjs.duration(allData?.avgDuration || 0, 'seconds').seconds() === 0 ? (
                                                0
                                            ) : (
                                                <>
                                                    <span>{dayjs.duration(allData?.avgDuration || 0, 'seconds').seconds()}</span>秒
                                                </>
                                            )}
                                        </p>
                                        {/* <span className='font_blod'>{allData?.avgDuration || 0}</span> */}
                                    </Space>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <div className="data_content">
                        <div>
                            <h2>数据详情</h2>
                            <Button size="small" className="data_content_btn" onClick={() => setIsModalOpen(true)}>
                                生成报告
                            </Button>
                            <Modal
                                title="生成报告提示"
                                open={isModalOpen}
                                onOk={handleOk}
                                onCancel={handleCancel}
                                okText={'我知道了'}
                                cancelButtonProps={{
                                    style: { display: 'none' },
                                }}
                            >
                                <p>报告只支持展示单选、多选、判断、量表题型的数据</p>
                            </Modal>
                        </div>
                        <div className="data_content_main">
                            {data?.length
                                ? data.map((item, index) => {
                                      return <QuestionItemCom key={index} index={index} item={item}></QuestionItemCom>;
                                  })
                                : null}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChartsSurvey;
